import { render, staticRenderFns } from "./ZoomImage.vue?vue&type=template&id=dc5af4d4&scoped=true"
import script from "./ZoomImage.vue?vue&type=script&lang=js"
export * from "./ZoomImage.vue?vue&type=script&lang=js"
import style0 from "./ZoomImage.vue?vue&type=style&index=0&id=dc5af4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5af4d4",
  null
  
)

export default component.exports